module.exports = __webpack_public_path__ + "img/ingwersalat-cutted.d4c010fa.png";